/* eslint-disable jsx-a11y/alt-text */
import React from "react";

//const NO_SEASON_NAME = "Текущий семестр"
const SPRING_SEASON_NAME = "Весенний семестр"
const FALL_SEASON_NAME = "Осенний семестр"
const SUMMER_SEASON_NAME = "Летний семестр"

//const NO_SEASON_ID = 0
// const SPRING_SEASON_ID = 1
// const FALL_SEASON_ID = 2
// const SUMMER_SEASON_ID = 3

// // export const DEFAULT_SEASON = SPRING_SEASON_ID //NO_SEASON_ID

// const SEASONS = [
//   //{id: NO_SEASON_ID, name: NO_SEASON_NAME},
//   { id: FALL_SEASON_ID, name: FALL_SEASON_NAME },
//   { id: SPRING_SEASON_ID, name: SPRING_SEASON_NAME },
//   { id: SUMMER_SEASON_ID, name: SUMMER_SEASON_NAME }
// ]
const SemesterName = (id) => {
  let name
  switch (id) {
    case 1:
      name = SPRING_SEASON_NAME;
      break;
    case 2:
      name = FALL_SEASON_NAME;
      break;
    case 3:
      name = SUMMER_SEASON_NAME;
      break;
    default:
      name = SPRING_SEASON_NAME;
  }
  return name
}

export default SemesterName;